/** Mirrors the backend TemplateTextFieldsCannotExceedMaxLengthOnCreateOrUpdate limit. */
export const TEMPLATE_TEXT_MAX_LENGTH = 250;

export const templateTextLimitMessage = (label: string) =>
  `${label} cannot exceed ${TEMPLATE_TEXT_MAX_LENGTH} characters`;

export const exceedsTemplateTextLimit = (value?: string | null) =>
  (value?.length ?? 0) > TEMPLATE_TEXT_MAX_LENGTH;
